import React, { useEffect, useState, useRef } from 'react';
import { Route, Switch, useRouteMatch, useLocation, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import { Pivot, PivotItem, PivotLinkSize } from 'office-ui-fabric-react/lib/Pivot';
import {
  fetchDimensionListOverview,
  fetchDimensionListActivity,
} from '../../actions/dimensionList';
import { fetchUsersByRoles } from '../../actions/users';
import { fetchContract } from '../../actions/contracts';
import AddDimensionListOverview from '../AddDimensionListOverview';
import AddDimensionListDetails from '../AddDimensionListDetails';
import PageTitle from '../../components/PageTitle';
import Main from '../../components/Main';
import DimensionListActionRequired from '../../components/DimensionListActionRequired';
import styles from './EditDimensionList.style';

const EditDimensionList = () => {
  const dispatch = useDispatch();
  const { path, url } = useRouteMatch();
  const { pathname, listFormData } = useLocation();
  const history = useHistory();
  const [selectedKey, setSelectedKey] = useState('overview');
  const ref = useRef();

  const { listId } = useParams();
  const dimensionList = useSelector(state => get(state, `entities.dimensionLists.${listId}`));

  const contracts = useSelector(state => Object.values(get(state, 'entities.contracts', {})));

  let reviewer;
  if (contracts && contracts.length > 0)
    reviewer = contracts
      ?.map(contract => ({
        contractId: contract.contractId,
        id:
          contract.metadata.businessProcessingManager.oid ||
          contract.metadata.businessProcessingManager,
      }))
      .filter(
        contract => contract.contractId === dimensionList?.associatedContractDetails[0].contractId,
      );

  let dimensionListWithReviewer;
  if (reviewer && reviewer.length > 0)
    dimensionListWithReviewer = { ...dimensionList, reviewer: { reviewerId: reviewer[0]?.id } };

  useEffect(() => {
    if (pathname.includes('/details')) {
      setSelectedKey('details');
    } else {
      setSelectedKey('overview');
    }
  }, [pathname, ref]);

  useEffect(() => {
    dispatch(fetchDimensionListOverview(listId, { useCache: false }));
    dispatch(fetchUsersByRoles(['businessProcessingManager']));
    dispatch(fetchDimensionListActivity(listId));
  }, [dispatch, listId]);

  useEffect(() => {
    if (
      dimensionList?.associatedContractDetails &&
      dimensionList?.associatedContractDetails?.length === 1
    )
      dispatch(fetchContract(dimensionList.associatedContractDetails[0].contractAddress));
  }, [dimensionList]);

  return (
    <>
      <PageTitle>Edit List</PageTitle>

      <Main className={styles.tabsContent}>
        <div className={styles.actionRequiredWrapper}>
          <DimensionListActionRequired listId={listId} />
        </div>
        <Pivot
          className={styles.tabs}
          aria-label="Dimension List sections"
          linkSize={PivotLinkSize.large}
          selectedKey={selectedKey}
          onLinkClick={item => {
            const formData = pathname.includes('/details') ? listFormData : ref.current.values;
            history.push({
              pathname: item.props.href,
              listFormData: formData,
            });
          }}
        >
          <PivotItem headerText="Overview" itemKey="overview" href={url} />
          <PivotItem headerText="Details" itemKey="details" href={`${url}/details`} />
        </Pivot>

        <Switch>
          <Route
            exact
            path={path}
            component={() => (
              <AddDimensionListOverview
                ref={ref}
                dimensionList={dimensionListWithReviewer || dimensionList}
              />
            )}
          />
          <Route exact path={`${path}/details`} component={AddDimensionListDetails} />
        </Switch>
      </Main>
    </>
  );
};

export default EditDimensionList;
